import React, { useEffect, useState } from "react";
import { ErrorMessage, Form, Formik } from "formik";
import "./style.css";
import FormikControl from "../../../componenets/FormikReusable/FormikControl";

const GradeHistory = ({ length }) => {
  var rows = [],
    len = length;
  console.log("rowslength", length);
  for (let i = 1; i < len; ++i) {
    rows.push(i);
  }
  console.log("rowslength", rows);
  return (
    <>
      {rows.length == "" ? null : (
        <div className="" style={{ height: "fit-content" }}>
          <h3>Fill The Previous Standard Grade History</h3>
          <table className="table table-striped">
            <tbody>
              {rows.map((curr, i) => {
                return (
                  <>
                    <tr>
                      <div class="" style={{ height: "fit-content" }}>
                        <div class="row" key={i}>
                          <div class="col-sm">
                            {/* <FormikControl control='input' type='text' label={`Standard:${i+1}`} name={`stds[${i}].std`} /> */}
                            <h5>Standard {`${i + 1}`} </h5>
                          </div>
                          <div class="col-sm">
                            <FormikControl
                              control="input"
                              type="text"
                              label={`Remarks of Standard:${i + 1}`}
                              name={`stds[${i}].remark`}
                            />
                          </div>
                          <div class="col-sm">
                            <FormikControl
                              control="input"
                              type="text"
                              label={`Percentage of Standard:${i + 1}`}
                              name={`stds[${i}].percentage`}
                            />
                          </div>
                        </div>
                      </div>
                    </tr>
                  </>
                );
              })}
            </tbody>
          </table>
        </div>
      )}
    </>
  );
};

export default GradeHistory;
